import { PLATFORMS } from '../enums/platforms';

export default function PlatformLogo({ platformKey, style }) {
    const platform = PLATFORMS[platformKey];
    if (!platform?.logo && !platform?.icon) return null;

    if (!platform.logo) {
        const Glyph = platform.icon;
        return (
            <div
                aria-label={platform.name}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '36px',
                    width: '36px',
                    minWidth: '36px',
                    minHeight: '36px',
                    aspectRatio: '1',
                    boxSizing: 'border-box',
                    borderRadius: '10px',
                    border: '1px solid var(--surface-8)',
                    background: 'var(--surface-9)',
                    color: 'var(--surface-4)',
                    ...style,
                }}
            >
                <Glyph size={20} />
            </div>
        );
    }

    return (
        <img
            src={platform.logo}
            alt={platform.name}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                height: '36px',
                width: '36px',
                minWidth: '36px',
                minHeight: '36px',
                aspectRatio: '1',
                boxSizing: 'border-box',
                borderRadius: '10px',
                maxWidth: '36px !important',
                maxHeight: '36px !important',
                ...style
            }}
        />
    );
}
